"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AircraftSeat = void 0;
const react_1 = __importDefault(require("react"));
const useSingleDoubleClick_1 = require("../../../hooks/useSingleDoubleClick");
const classFunctions_1 = require("../../../utils/classFunctions");
const Icon_1 = require("../../Icon");
const Tooltip_1 = require("../../Tooltip");
require("./index.scss");
const className = 'seat-selection-place';
const AircraftSeat = (props) => {
    const { row = '', column = '', price = '', active, selected, disabled, hidden, reserved, booked, bordered, isClickable, modificators, onSeatClick, onSeatDoubleClick, } = props;
    const classNames = (0, classFunctions_1.getClassNames)(className, [
        modificators,
        active ? 'active' : undefined,
        selected ? 'selected' : undefined,
        (disabled || booked) ? 'disabled' : undefined,
        hidden ? 'hidden' : undefined,
        reserved ? 'reserved' : undefined,
        bordered ? 'bordered' : undefined,
        isClickable ? 'clickable' : undefined,
    ]);
    const seatLabel = `${row}${column}`;
    const isClickActionEnable = isClickable;
    const tooltipText = [
        `Seat: ${seatLabel}`,
        price ? `Price: ${price}` : '',
    ].filter(s => s !== '').join(', ');
    const onClick = () => {
        isClickActionEnable && (onSeatClick === null || onSeatClick === void 0 ? void 0 : onSeatClick(seatLabel));
    };
    const onDoubleClick = () => {
        isClickActionEnable && (onSeatDoubleClick === null || onSeatDoubleClick === void 0 ? void 0 : onSeatDoubleClick(seatLabel));
    };
    const [handleClick, handleDoubleClick] = (0, useSingleDoubleClick_1.useSingleDoubleClick)(onClick, onDoubleClick);
    return (react_1.default.createElement("div", { className: classNames, onClick: handleClick, onDoubleClick: handleDoubleClick }, !hidden && (react_1.default.createElement(Tooltip_1.Tooltip, { text: tooltipText, modificators: 'seat-selection' },
        react_1.default.createElement("div", { className: `${className}__icon` }, booked ? react_1.default.createElement(Icon_1.Icon, { name: 'plan-seat-passenger' }) : react_1.default.createElement(Icon_1.Icon, { name: 'plan-seat-color' }))))));
};
exports.AircraftSeat = AircraftSeat;
//# sourceMappingURL=index.js.map